module.exports = __webpack_public_path__ + "img/logo.4a3c9c53.png";